import PopupOpener from 'mewe/pods/components/basic-ui/mw-popup/base/component';
import layout from './template.hbs';
import './styles.scss';
import { tracked } from '@glimmer/tracking';
import { getElWidth } from 'mewe/utils/elements-utils';

export default class MwTooltipPopup extends PopupOpener {
  @tracked showPopup = true;

  layout = layout;

  popupType = 'dropdown-popup';
  closeOnClickOutside = true;
  closeOnScroll = true;
  closeOnHoverOutside = true;

  get dropdownPosition() {
    const position = this.getDefaultDropdownOptions();

    Object.assign(position, {
      margin: 4,
      placement: {
        top: true,
        left: true,
        positionType: 'fixed',
      },
      translate: {
        x: 0,
        altY: -8,
      },
      reposition: {
        elementWidth: 200,
      },
      anticlose: {
        parentWidth: position.parentSize.width,
        parentHeight: position.parentSize.height,
      },
    });

    return position;
  }

  get computedStyle() {
    const parentWidth = getElWidth(this.args.params.parent);
    return this.dropdownStyle.dropdownStyle + `transform: translateX(calc(-50% + ${parentWidth / 2}px));`;
  }
}


